import { EntityState } from '@ngrx/entity';
import { ChatExchange } from '../../../models/ai-insights/chat-exchange';
import { sessionEntityAdapter, sessionsEntityAdapter } from './ai-insights-adapters';
import { v1 as generateUUID } from 'uuid';
import { ChatSuggestions } from '../../../models/ai-insights/chat-suggestions';
import { ChatSession } from '../../../models/ai-insights/chat-session';

export const DEFAULT_SESSIONS_PAGE_SIZE = 10;
export const DEFAULT_SESSION_PAGE_SIZE = 5;

interface ChatSessionDetail extends EntityState<ChatExchange> {
}

interface ChatSessions extends EntityState<ChatSession> {
}

export interface AiInsightsFeatureState {
  sessionId: string; // (selected/active) session ID
  session: ChatSessionDetail;
  sessionPage: number,
  sessionTotalPages: number,
  sessionPageSize: number,

  chatSuggestions: ChatSuggestions;

  sessions: ChatSessions,
  sessionsPage: number,
  sessionsTotalPages: number,
  sessionsPageSize: number
}

export const getChatSessionId = () => 's' + generateUUID();

export const AiInsightsInitialState: AiInsightsFeatureState = {

  sessionId: getChatSessionId(),
  session: sessionEntityAdapter.getInitialState(),
  sessionPage: null,
  sessionTotalPages: null,
  sessionPageSize: DEFAULT_SESSION_PAGE_SIZE,

  chatSuggestions: null,

  sessions: sessionsEntityAdapter.getInitialState(),
  sessionsPage: null,
  sessionsTotalPages: null,
  sessionsPageSize: DEFAULT_SESSIONS_PAGE_SIZE,
};
